import React, {useState, useContext} from 'react';
import {makeStyles, withStyles} from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import SearchEventClient from './SearchEventClient/SearchEventClient';
import AddEventClient from './AddEventClient/index.js';
import {Card} from '@material-ui/core';
import {ThemeContext} from '../../../themes/ThemeProvider';

const AntTabs = withStyles({
  root: {
    width: '100%',
  },
  indicator: {
    display: 'none',
  },
  centered: {
    alignItems: 'center',
    justifyContent: 'center',
  },
})(Tabs);

const AntTab = withStyles((theme) => ({
  root: {
    'minWidth': '0px',
    'position': 'relative',
    'display': 'block',
    'borderRadius': '30px',
    'textAlign': 'center',
    'transition': 'all .5s',
    'padding': '10px 15px',
    'color': 'black',
    'height': 'auto',
    'opacity': '1',
    'margin': '5px 0px 15px 3px',
    'float': 'none',
    [theme.breakpoints.down(769)]:
    {
      padding: '5px 10px',
    },
    '& + button': {
      margin: '5px 0px 15px 3px',
    },
    '&$selected': {
      '&, &:hover': {
        color: 'white',
        backgroundColor: 'white',
        boxShadow: '0 0px 10px -5px rgb(118 116 252);',
      },
    },
  },
  selected: {},
  wrapper: {
    lineHeight: '24px',
    textTransform: 'capitalize',
    fontSize: '15px',
    fontWeight: '500',
    position: 'relative',
    display: 'block',
    color: 'inherit',
    [theme.breakpoints.down(769)]:
    {
      fontSize: '13px !important',
    },

  },
}))((props) => <Tab disableRipple {...props} />);

const useStyles = makeStyles((theme) => ({
  'root': {
    flexGrow: 1,
    width: '100%',
    borderRadius: '5px',
  },
  'padding': {
    padding: '40px',
  },
  'MuiTabScrollButton-root': {
    color: 'black',
  },
  'demo1': {
    color: 'white',
    borderRadius: '6px',
  },
  'searchRuleButton': {
    margin: '-8px 0 8px',
  },
  'cardStyles': {
    backgroundColor: '#FFF',
    padding: '15px',
    marginBottom: 10,
    borderRadius: 8,
  },
}));

export default function EventClientSubTabs() {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = useStyles();
  const classes1 = reusableInputStyles();
  const [value, setValue] = useState(0);
  const [eventTacticCode, setEventTacticCode] = useState(null);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <Card className={`${classes1.cardBordernoneStyles} mb-0`} elevation={0}>
      <div className={classes.root}>
        <AntTabs
          className={classes.demo1}
          value={value}
          onChange={handleChange}
          aria-label="ant example"
          variant="scrollable"
          scrollButtons="auto"
        >
          <AntTab label="Search Client Event Tactics" />
          <AntTab label="Attach Client Event Tactics" />
        </AntTabs>
        <Typography />
        <div className={classes.subContent}>
          {value === 0 && (
            <SearchEventClient
              setEventTacticCode={setEventTacticCode}
              setValue={setValue}
              value={value}
            />
          )}
          {value === 1 && (
            <AddEventClient
              eventTacticCode={eventTacticCode}
              setEventTacticCode={setEventTacticCode}
              setValue={setValue}
              value={value}
            />
          )}
        </div>
      </div>
    </Card>
  );
}
